import React, { Component, Fragment } from 'react'
import { Container,Row, Col, Card, Button } from 'react-bootstrap'
import littleFlyer1 from '../../asset/image/littleFlyer1.png';
import littleFlyer2 from '../../asset/image/littleFlyer2.jpg';

import { Link } from 'react-router-dom';
//----------------Upcoming Events------------
export class ResentProject extends Component {
  render() {
    return (
      <Fragment>
        <br /><br /> <br />  
        <Container fluid={true} className='text-center projectBackPic'>
        
           <h1 className='h1Tag p-3'>Upcoming Events</h1>
              <div className='bottom'></div>
         
      
            <Row>
                <Col lg={4} md={6} sm={12}>
                <Card className='projectCard'>
      <Card.Img variant="top" src={littleFlyer1} height='10%'/>
      <Card.Body>
        <Card.Title className='h2Tag'>Markham Eid Bazaar</Card.Title>
        <Card.Text className='pTag'>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary"><Link className='linkStyle' to="/projectdetails"> View More </Link></Button>
      </Card.Body>
    </Card>
                </Col>
                <Col lg={4} md={6} sm={12}>
                    <Card className='projectCard' >
      <Card.Img variant="top" src={littleFlyer2} />
      <Card.Body>
        <Card.Title className='h2Tag'>Project 2</Card.Title>
        <Card.Text className='pTag'>
          Some quick example text to build on the card title and make up the
          bulk of the card's content.
        </Card.Text>
        <Button variant="primary"><Link className='linkStyle' to="/projectdetails"> View More </Link></Button>
      </Card.Body>
    </Card>
                </Col>
            
            </Row>

        </Container>

      </Fragment>
    )
  }
}

export default ResentProject
